import { EmbedVideoBlockSchema } from '@blocksuite/affine-model';

import { createEmbedEdgelessBlockInteraction } from '../common/embed-block-element.js';
import { toEdgelessEmbedBlock } from '../common/to-edgeless-embed-block.js';
import { EmbedVideoBlockComponent } from './embed-video-block.js';

export class EmbedEdgelessVideoBlockComponent extends toEdgelessEmbedBlock(
  EmbedVideoBlockComponent
) {}

export const EmbedVideoBlockInteraction = createEmbedEdgelessBlockInteraction(
  EmbedVideoBlockSchema.model.flavour
);
